import Vue from 'vue';
import VueRouter from 'vue-router';
import { userType } from '@/plugins/enums';
import store from './store/store';
import { baseStore } from 'erp-skeleton-library/base-store/base-store';
import { hideFabButtons, isNullOrEmpty, verifyDebug } from 'erp-skeleton-library/utils';
import { usersTenants } from './plugins/enums';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR ],
          },
          component: () => import('./views/Dashboard.vue'),
        },
        {
          path: '/register/courses',
          name: 'courses',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/courses/Courses.vue'),
        },
        {
          path: '/register/courses/new',
          name: 'courses-new',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/courses/CoursesRegister.vue'),
        },
        {
          path: '/register/courses/:id',
          name: 'courses-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/courses/CoursesRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/config/courses/type',
          name: 'courses-type',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/courses/CoursesType.vue'),
        },
        {
          path: '/customers',
          name: 'customers',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/customers/Customer.vue'),
        },
        {
          path: '/customers/new',
          name: 'customer-register',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/customers/CustomerRegister.vue'),
        },
        {
          path: '/customers/:id',
          name: 'customer-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/customers/CustomerRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/register/students',
          name: 'students',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/students/Student.vue'),
        },
        {
          path: '/register/students/new',
          name: 'students-register',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/students/StudentRegister.vue'),
        },
        {
          path: '/register/students/:id',
          name: 'students-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/students/StudentRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);
            return { id };
          },
        },
        {
          path: '/register/partners',
          name: 'partners',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/partners/Partner.vue'),
        },
        {
          path: '/register/partners/new',
          name: 'partners-register',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/partners/PartnerRegister.vue'),
        },
        {
          path: '/register/partners/:id',
          name: 'partners-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/partners/PartnerRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/register/instructors',
          name: 'instructors',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/instructors/Instructor.vue'),
        },
        {
          path: '/register/instructors/new',
          name: 'instructors-register',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/instructors/InstructorRegister.vue'),
        },
        {
          path: '/register/instructors/:id',
          name: 'instructors-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/instructors/InstructorRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/register/collaborators',
          name: 'collaborators',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/Collaborator.vue'),
        },
        {
          path: '/register/collaborators/new',
          name: 'collaborators-register',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/CollaboratorRegister.vue'),
        },
        {
          path: '/register/collaborators/:id',
          name: 'collaborators-edit',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/collaborators/CollaboratorRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/register/places',
          name: 'places',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
          },
          component: () => import('./views/Places.vue'),
        },
        {
          path: '/classes',
          name: 'classes',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_SUPPORT, userType.TYPE_USER, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/classes/Classes.vue'),
        },
        {
          path: '/classes/new',
          name: 'classes-register',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/classes/ClassesRegister.vue'),
        },
        {
          path: '/classes/:id',
          name: 'classes-edit',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/classes/ClassesRegister.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);
            const students = Number.parseInt(route.query.students);
            const certifications = Number.parseInt(route.query.certifications);

            return { id, students, certifications };
          },
        },
        {
          path: '/classes/attendances/:id',
          name: 'classes-attendances',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/classes/ClassesAttendances.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/classes/grades/:id',
          name: 'classes-grades',
          meta: {
            userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/classes/ClassessGrades.vue'),
          props: (route) => {
            const id = Number.parseInt(route.params.id);

            return { id };
          },
        },
        {
          path: '/config/file-types',
          name: 'file-types',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_SUPPORT ],
          },
          component: () => import('./views/FileTypes.vue'),
        },
        {
          path: '/profile',
          name: 'profile',
          meta: {
            userType: [ userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
            tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER ],
            student: true,
          },
          component: () => import('./views/Profile.vue'),
        },
      ],
    },
    {
      path: '*',
      name: 'login',
      component: () => import('./views/Index.vue'),
    },
  ],
});


router.beforeEach((to, from, next) => {
  hideFabButtons();
  verifyDebug();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/login',
      });
    } else if (!sessionStorage.getItem('tokenIsValid')) {
      store.dispatch('users/verifyUserStatus', baseStore.state.appUser.id)
           .then(() => {
             sessionStorage.setItem('tokenIsValid', 'true');
             next();
           });
    } else {
      if (navigationGuard(to.meta, baseStore.state.appUser)) {
        next();
      } else {
        next({ path: '/dashboard' });
      }
    }
  } else {
    if (store.getters.loggedIn) {
      next({
        path: '/dashboard',
      });
    } else {
      next();
    }
  }
});

function navigationGuard(pathMeta, appUser) {
  if (appUser.type !== userType.TYPE_USER) {
    if (pathMeta.userType.includes(parseInt(appUser.type))) {
      return true;
    } else {
      return pathMeta.userType.includes(parseInt(appUser.type));
    }
  }

  //Tenant (Type User)
  if (hasTenantPermission(pathMeta)) {
    if (pathMeta.hasOwnProperty('student') && appUser.student) {
      return true;
    }

    if (pathMeta.tenantUserType.includes(store.getters.getUserType.tenantUserType)) {
      return (!isNullOrEmpty(appUser.tenants) && appUser.tenants[0].tenant.pra);
    } else if(!appUser.student) {
      return pathMeta.tenantUserType.includes(store.getters.getUserType.tenantUserType);
    } else {
      return pathMeta.userType.includes(parseInt(appUser.type));
    }
  }
}

function hasTenantPermission(pathMeta) {
  return pathMeta.tenantUserType;
}

export default router;
